import Api from "utils/Api";

const GET_ME_URL = `/account/user/my_profile/`;
const LOGOUT_BLACKLIST_URL = "/account/auth/logout/";
const GET_REFRESH_URL = "/account/auth/refresh/";
const SEND_OTP_URL = "/account/auth/get_otp/";
const CHECK_OTP_URL = "/account/auth/check_otp/";
const UPDATE_PROFILE_URL = (id) => `/account/user_update/${id}/`;
const GET_MY_SUPERMARKET_URL = `/account/supermarket_info/my_supermarket/`;
const CREATE_SUPERMARKET_URL = `/account/supermarket_info/`;
const UPDATE_SUPERMARKET_URL = (id) => `/account/supermarket_info/${id}/`;
const GET_CREDIT_URL = () => `/account/check-credit/`;

const GET_ADDRESS_LIST_URL = `/account/address/`;
const UPDATE_ADDRESS_URL = (id) => `/account/address/${id}/`;

export const GetUserByToken = () => {
  return Api.get(GET_ME_URL);
};

export const LogoutBlacklist = () => {
  return Api.post(LOGOUT_BLACKLIST_URL);
};

export const GetUserByRefresh = (refresh) => {
  return Api.post(GET_REFRESH_URL, { refresh });
};

export const SendOTPCode = (data) => {
  return Api.post(SEND_OTP_URL, data);
};

export const CheckOTPCode = (data) => {
  return Api.post(CHECK_OTP_URL, data);
};

export const UpdateProfile = (id, data) => {
  return Api.patch(UPDATE_PROFILE_URL(id), data);
};

export const GetAdressList = () => {
  return Api.get(GET_ADDRESS_LIST_URL, { params: { page_size: 1000 } });
};

export const CreateAddress = (data) => {
  return Api.post(GET_ADDRESS_LIST_URL, data);
};

export const DeleteAddress = (id) => {
  return Api.delete(UPDATE_ADDRESS_URL(id));
};

export const GetSingleAddress = (id) => {
  return Api.get(UPDATE_ADDRESS_URL(id));
};

export const UpdateAddress = (id, data) => {
  return Api.put(UPDATE_ADDRESS_URL(id), data);
};

export const GetMySupermarket = () => {
  return Api.get(GET_MY_SUPERMARKET_URL);
};

export const CreateSuperMarket = (data) => {
  return Api.post(CREATE_SUPERMARKET_URL, data);
};

export const UpdateSuperMarket = (id, data) => {
  return Api.patch(UPDATE_SUPERMARKET_URL(id));
};

export const GetUserCredit = (params) => {
  return Api.get(GET_CREDIT_URL(), { params });
};
